module.exports = __webpack_public_path__ + "static/media/login-produccion.afd62984.jpg";